import { makeAutoObservable } from "mobx";
import {
  pagingADSMPatient,
} from "./PatientADSMService";
import "react-toastify/dist/ReactToastify.css";
import { toast } from "react-toastify";

export default class PatientADSMStore {
  patientADSMList = [];
  selectedPatientADSM = null;
  selectedPatientADSMList = [];
  totalElements = 0;
  totalPages = 0;
  page = 1;
  rowsPerPage = 10;
  keyword = "";
  statusAdsm = null;
  loadingInitial = false;
  shouldOpenEditorDialog = false;
  shouldOpenConfirmationDialog = false;
  shouldOpenConfirmationDeleteListDialog = false;
  searchObject = {
    statusAdsm: null,
    fromDate: null,
    toDate: null,
    numberDashboard: null,
  };
  constructor() {
    makeAutoObservable(this);
  }

  setLoadingInitial = (state) => {
    this.loadingInitial = state;
  };

  handleSetSearchObject = (item) => {
    if (item.pageIndex) {
      this.page = item.pageIndex;
      //this.rowsPerPage = item.pageSize
    }
    this.searchObject = item;
  };

  updatePageData = (item) => {
    if (item != null) {
      this.page = 1;
      this.keyword = item.keyword;
      this.search();
    } else {
      this.search();
    }
  };

  search = async () => {
    this.loadingInitial = true;
    var searchObject = {
      ...this.searchObject,
      keyword: this.keyword,
      pageIndex: this.page,
      pageSize: this.rowsPerPage,
    };

    try {
      let data = await pagingADSMPatient(searchObject);
      this.patientADSMList = data.data.content;
      this.totalElements = data.data.totalElements;
      this.totalPages = data.data.totalPages;
      this.setLoadingInitial(false);
    } catch (error) {
      console.log(error);
      toast.warning("toast.load_fail");
      this.setLoadingInitial(false);
    }
  };

  setPage = (page) => {
    this.page = page;
    this.updatePageData();
  };

  setRowsPerPage = (event) => {
    this.rowsPerPage = event.target.value;
    this.page = 1;
    this.updatePageData();
  };

  handleChangePage = (event, newPage) => {
    this.setPage(newPage);
  };

  handleClose = () => {
    this.shouldOpenEditorDialog = false;
    this.shouldOpenConfirmationDialog = false;
    this.shouldOpenConfirmationDeleteListDialog = false;
    this.updatePageData();
  };

  handleDeleteList = () => {
    this.shouldOpenConfirmationDeleteListDialog = true;
  };

  handleSelectPatientADSM = (ethnicity) => {
    this.selectedPatientADSM = ethnicity;
  };

  handleSelectListPatientADSM = (ethnicitys) => {
    this.selectedPatientADSMList = ethnicitys;
    console.log(this.selectedPatientADSMList);
  };

  resetSearchObject = () => {
    this.searchObject = {
      statusAdsm: null,
      fromDate: null,
      toDate: null,
      numberDashboard: null,
    }
    this.keyword = "";
    this.page = 1;
    this.rowsPerPage = 10;
  }
}
